import { Component, OnDestroy, OnInit } from "@angular/core";
import { LabsPageService, LabAccess } from "../labs-page.service";
import { Location } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { Dictionary } from "src/app/store/models/common_types";
import { GlobalSubheaderDataService } from "src/app/global-subheader/global-subheader-data.service";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/store/state/app.state";
import { Subject } from "rxjs";
import {
  VAIconRegistryService,
  checkCircle,
  exclamationTriangle,
  arrowCircleLeft,
  arrowCircleRight,
} from "@va/core-library/icons";

@Component({
  selector: "app-labs-page",
  templateUrl: "./labs-page.component.html",
  styleUrls: ["./labs-page.component.scss"],
  host: { class: "labs-page-component" },
})
export class LabsPageComponent implements OnInit, OnDestroy {
  labsUrls: Dictionary<any>;
  selected: number;
  isCollapsed = false;
  frameUrl: SafeUrl = "";
  loading = false;
  iframeLoading = true;
  pageName = "";
  currentRoute = "";
  mainRoute = "labs";
  notFound = false;
  isLabsPage = true;
  notFoundMsg = "";
  notExcel = true;

  constructor(
    public labsPageService: LabsPageService,
    private sanitizer: DomSanitizer,
    private router: Router,
    private globalSubheaderDataService: GlobalSubheaderDataService,
    private route: ActivatedRoute,
    private store: Store<AppState>,
    private location: Location,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([
      checkCircle,
      exclamationTriangle,
      arrowCircleLeft,
      arrowCircleRight,
    ]);
  }

  async ngOnInit() {
    if (window.addEventListener) {
      window.addEventListener("message", this.receiveMessage.bind(this), false);
    }
    this.labsPageService.checkCompleteSubject = new Subject<any>();
    this.labsPageService.checkCompleteSubject.subscribe(() => {
      if (
        "menuOption" in this.labsPageService.labsUser.is_data_check &&
        "globalSettings" in this.labsPageService.labsUser.is_data_check
      ) {
        this.labsPageService.getLabsData().subscribe((response) => {
          if (
            (response.aceessType.firmAccess !== LabAccess.NONE &&
              response.aceessType.userAccess !== LabAccess.NONE) ||
            this.labsPageService.labsUser.is_sellside
          ) {
            this.initPageLoad();
          } else {
            this.router.navigate([`/labs`]);
          }
        });
      }
    });
    await this.labsPageService.initLabsUser(this.store);
  }

  ngOnDestroy(): void {
    this.labsPageService.checkCompleteSubject.unsubscribe();
  }

  initPageLoad() {
    this.currentRoute = this.router.url.split("?")[0];
    this.route.params.subscribe((param) => {
      if (param.pageName) {
        this.pageName = param.pageName;
      }
    });
    let queryParams = "";
    const url = window.location.href;
    const paramArry = url.split("?");
    if (paramArry.length > 1) {
      queryParams = `?${paramArry[1]}`;
    }
    this.loading = true;
    if (
      this.labsPageService.labsUser.is_lab_access ||
      this.labsPageService.labsUser.is_lab_menu_access
    ) {
      if (
        this.labsPageService.labsUser.is_lab_access ||
        this.labsPageService.labsUser.is_sellside
      ) {
        this.initLabsPages(queryParams);
      } else if (this.labsPageService.labsUser.is_lab_menu_access) {
        this.initLabMenuPage(queryParams);
      }
    } else {
      this.router.navigate([`/home`]);
    }
  }

  initLabMenuPage(queryParams: string) {
    if (queryParams.includes("?")) {
      queryParams = `${queryParams}&pagename=${this.pageName}`;
    } else {
      this.pageNotFound("Page not found");
      return;
    }

    this.labsPageService.getLabsPages(queryParams).subscribe((response) => {
      this.loading = false;
      const keys = Object.keys(response);
      if (keys.some((x) => x !== "Error") && keys.length > 0) {
        this.setFrameUrl(response[keys[0]][0].url, false);
      } else {
        this.pageNotFound("You are not authorized.");
        setTimeout(() => {
          this.router.navigate([`/home`]);
        }, 3000);
      }
    });
  }

  initLabsPages(queryParams) {
    const navParams = this.labsPageService.labsPagesParams;
    this.labsPageService
      .getLabsUrls(queryParams, navParams, "lab")
      .subscribe((response) => {
        this.loadLabsPages(response);
      });
  }

  loadLabsPages(response: any) {
    this.labsUrls = response;
    this.loading = false;

    if (this.pageName !== "") {
      this.selectedUrlFromMenu(this.pageName);
    } else {
      this.loadRoute(Object.values(this.labsUrls)[0][0].pagename);
    }
  }

  selectedUrlFromMenu(pageName: string) {
    let pageFound = false;
    this.notExcel = true;
    const keys = Object.keys(this.labsUrls);
    for (let index = 0; index < keys.length; index++) {
      const data = this.labsUrls[keys[index]];
      for (const item of data) {
        if (item.pagename === pageName) {
          this.selected = item.id;
          if (item.pagename === "exceltemplates") {
            this.notExcel = false;
            pageFound = true;
            break;
          }
          this.setFrameUrl(item.url);
          pageFound = true;

          break;
        }
      }
    }
    if (!pageFound) {
      this.pageNotFound("Page not found");
    }
  }

  loadRoute(pagename: string) {
    this.router.navigate([`/labs/${pagename}`, {}]);
  }

  onLabUrlClick(data) {
    this.selected = data.id;
    this.setFrameUrl(data.url, true);
  }

  setFrameUrl(url, menuClick = false) {
    const baseUrl = `${location.protocol}//${location.host}`;
    if (!url.includes(baseUrl)) {
      const pathArray = url.split("/");
      const protocol = pathArray[0];
      const host = pathArray[2];
      const newUrl = `${protocol}//${host}`;
      url = url.replace(newUrl, baseUrl);
    }
    if (!menuClick) {
      url = this.sanitizeURL(url);
    }
    let queryParams = "";
    if (this.router.url.split("?").length > 1) {
      queryParams = this.router.url.split("?")[1];
    }
    if (this.labsPageService.recentlyNavigatedPage !== "") {
      const queryOperator = String(url).includes("?") ? "&" : "?";
      url = `${url}${queryOperator}recentlyNavigatedPage=${this.labsPageService.recentlyNavigatedPage}`;
      this.labsPageService.recentlyNavigatedPage = "";
    }
    // if user logout in anothertab, getBreadcrumbsData check user logged in while swtching labs page.
    if (queryParams !== "" && !menuClick) {
      if (String(url).includes("?")) {
        url = `${url}&${queryParams}`;
      } else {
        url = `${url}?${queryParams}`;
      }
    }
    this.iframeLoading = true;
    this.globalSubheaderDataService
      .getBreadcrumbsData(`page=labs`)
      .subscribe(() => {
        this.frameUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      });
  }

  onLabFrameLoad = () => {
    this.iframeLoading = false;
  };

  pageNotFound(msg: string) {
    this.notFoundMsg = msg;
    this.notFound = true;
    this.loading = false;
    this.iframeLoading = false;
  }

  receiveMessage(event) {
    if (event.data.source === "plotly") {
      if (
        event.data.name === "surprice" ||
        event.data.name === "revision" ||
        event.data.name === "keyvalue"
      ) {
        if (event.data.redirect_to === "company") {
          this.router.navigate([`/company/${event.data.ticker}`, {}]);
        }
        if (event.data.redirect_to === "comps") {
          if (event.data.iscustom === "true") {
            this.router.navigate([
              `/comptables/user/${event.data.compsid}`,
              {},
            ]);
          } else {
            this.router.navigate([
              `/comptables/system/${event.data.compsid}`,
              {},
            ]);
          }
        }
        if (event.data.redirect_to === "url") {
          let url = this.router.url;
          if (
            event.data.name === "surprice" ||
            event.data.name === "revision"
          ) {
            url = this.labsPageService.updateQueryStringParameter(
              url,
              "compsid",
              event.data.compsid,
            );
            this.location.go(url);
          }
          if (event.data.name === "keyvalue") {
            if ("ticker" in event.data) {
              url = this.labsPageService.updateQueryStringParameter(
                url,
                "ticker",
                event.data.ticker,
              );
              this.location.go(url);
            } else if (
              "filter_value" in event.data &&
              "filter_col" in event.data
            ) {
              let newUrl = "";
              if (event.data.filter_value && event.data.filter_col) {
                newUrl = this.labsPageService.updateQueryStringParameter(
                  url,
                  "filter_col",
                  event.data.filter_col,
                );
                newUrl = this.labsPageService.updateQueryStringParameter(
                  newUrl,
                  "filter_value",
                  event.data.filter_value,
                );
                if (event.data.search_value) {
                  newUrl = this.labsPageService.updateQueryStringParameter(
                    newUrl,
                    "search_value",
                    event.data.search_value,
                  );
                }
                if (url !== newUrl && encodeURI(url) !== newUrl) {
                  this.location.replaceState(newUrl);
                }
              } else {
                newUrl = url.split("?")[0];
                this.location.replaceState(newUrl);
              }
            }
          }
        }
      }
    }
    if (event.data.source === "redirection") {
      this.router.navigate([`/${event.data.redirect_to}`, {}]);
    }
  }

  sanitizeURL(url) {
    this.route.queryParams.subscribe((params) => {
      Object.keys(params).forEach((x) => {
        url = this.removeParameterFromUrl(url, x);
      });
    });
    return url;
  }

  removeParameterFromUrl(url, parameter) {
    return url
      .replace(new RegExp(`[?&]${parameter}=[^&#]*(#.*)?$`), "$1")
      .replace(new RegExp(`([?&])${parameter}=[^&]*&`), "$1");
  }
}
